import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from "../../../../sessionStorage";

export const getPrimaryColor = () => {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    if (!accountObj.accountOverrides) {
        return accountObj.account.primaryColor;
    } else {
        return accountObj.accountOverrides[0].primaryColor;
    }
}